import React from "react";
import { Box, Button, Typography } from "@mui/material";
import IconCircle from "../shared/IconCircle";
import { cardDescSx, cardTitleSx, FONT } from "../shared/styles";
import { BellAlertIcon } from "./icons";

function BrowserNotificationBanner({ onEnable, enabling }) {
  return (
    <Box
      sx={{
        mt: "32px",
        width: "100%",
        minHeight: 153,
        p: "24px",
        borderRadius: "8px",
        border: "1px solid #FFD591",
        bgcolor: "#FFF7E6",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
        <IconCircle bgcolor="#FFE7BA">
          <BellAlertIcon />
        </IconCircle>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="p" sx={cardTitleSx}>
            Browser Notifications Disabled
          </Typography>
          <Typography
            component="p"
            sx={{
              ...cardDescSx,
              mt: "4px",
              lineHeight: "24px",
            }}
          >
            Enable browser notifications to receive real-time alerts even when TrustChat is in the
            background
          </Typography>
          <Button
            type="button"
            onClick={onEnable}
            disabled={enabling}
            disableRipple
            sx={{
              mt: "8px",
              p: 0,
              minWidth: 0,
              border: "none",
              background: "none",
              color: "#FA8C16",
              fontFamily: FONT.family,
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "18px",
              textDecoration: "underline",
              textTransform: "none",
              "&:hover": {
                background: "none",
                textDecoration: "underline",
              },
              "&:disabled": {
                opacity: 0.6,
              },
            }}
          >
            {enabling ? "Enabling..." : "Enable Browser Notifications"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default BrowserNotificationBanner;
